// extracted by css-extract-rspack-plugin
export default {"body":"src-modules-desktop-components-TwoFaReminderModal-TwoFaReminderModal-module__body-K90LIn","titleWrapper":"src-modules-desktop-components-TwoFaReminderModal-TwoFaReminderModal-module__titleWrapper-q4Gvoe","description":"src-modules-desktop-components-TwoFaReminderModal-TwoFaReminderModal-module__description-XXPEd_","illustrationWrapper":"src-modules-desktop-components-TwoFaReminderModal-TwoFaReminderModal-module__illustrationWrapper-zoQbTo"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"body\":\"src-modules-desktop-components-TwoFaReminderModal-TwoFaReminderModal-module__body-K90LIn\",\"titleWrapper\":\"src-modules-desktop-components-TwoFaReminderModal-TwoFaReminderModal-module__titleWrapper-q4Gvoe\",\"description\":\"src-modules-desktop-components-TwoFaReminderModal-TwoFaReminderModal-module__description-XXPEd_\",\"illustrationWrapper\":\"src-modules-desktop-components-TwoFaReminderModal-TwoFaReminderModal-module__illustrationWrapper-zoQbTo\"}";
        // 1793873548485
        var cssReload = require("../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  